import { HttpParams } from '@angular/common/http';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SubSink } from 'subsink';
import * as moment from 'moment';

import { CALENDAR_LOCALE } from '../../../services/constant';
import { DownloadService } from '../download.service';

@Component({
  selector: 'app-download-list',
  templateUrl: './download-list.component.html',
  styleUrls: ['./download-list.component.scss']
})
export class DownloadListComponent implements OnInit, OnDestroy {
  startDate: Date = new Date(moment().format('YYYY') + '-01-01');
  endDate: Date = new Date(moment().format('YYYY') + '-12-30');
  minDate: Date;
  maxDate: Date;
  loading = false;
  currentPage = 1;
  itemsPerPage = 40;
  totalItems = 0;
  documentList = [];
  approvedList = [];
  isLoadingConfirm = false;
  showResults = false;
  successEmailList = [];
  failedEmailList = [];
  documentNumber = '';
  email = '';
  buyerName = '';

  calendarLocale = CALENDAR_LOCALE.TH;

  selectedMonth;
  modal: NgbModalRef;
  isCheckAll = false;

  private subs = new SubSink();

  constructor(private modalService: NgbModal, private downloadService: DownloadService) {}

  ngOnInit() {
    this.getDocumentRequestList();
  }

  getDocumentRequestList() {
    this.loading = true;
    const params = new HttpParams()
      .set('page_size', this.itemsPerPage.toString())
      .set('page', this.currentPage.toString())
      .set('status', 'False')
      .set('email', this.email)
      .set('buyer_name', this.buyerName)
      .set('start_date', this.startDate ? moment(this.startDate).format('YYYY-MM-DD') : '')
      .set('end_date', this.endDate ? moment(this.endDate).format('YYYY-MM-DD') : '')
      .set('document_number', this.documentNumber);
    this.subs.add(
      this.downloadService.getDocumentRequestList(params).subscribe(
        documents => {
          this.documentList = documents['results'];
          this.totalItems = documents['count'];
          this.loading = false;
        },
        error => {
          console.log('error', error);
        }
      )
    );
  }

  get yearRange() {
    const thisYear = new Date().getFullYear();
    return thisYear - 40 + ':' + thisYear;
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  search() {
    this.currentPage = 1;
    this.getDocumentRequestList();
  }

  clearSearch() {
    this.documentNumber = '';
    this.startDate = new Date(moment().format('YYYY') + '-01-01');
    this.endDate = new Date(moment().format('YYYY') + '-12-30');
    this.email = '';
    this.buyerName = '';
    this.getDocumentRequestList();
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  open(content) {
    this.showResults = false;
    this.modal = this.modalService.open(content);
  }

  toggleStatusChange() {
    this.approvedList = this.documentList.filter(obj => obj.status);
  }

  confirm() {
    this.isLoadingConfirm = true;
    this.subs.add(
      this.downloadService.updateDocumentRequest(this.approvedList).subscribe(
        res => {
          this.successEmailList = res.success_email_list;
          this.failedEmailList = res.failed_email_list;
        },
        error => {
          console.log('error', error);
        },
        () => {
          this.isLoadingConfirm = false;
          this.showResults = true;
          this.approvedList = [];
          this.getDocumentRequestList();
        }
      )
    );
  }

  checkAll() {
    this.documentList.map(obj => {
      obj['status'] = this.isCheckAll;
    });
    this.toggleStatusChange();
  }

  deleteDownloadRequest(id) {
    this.downloadService.deleteDocumentRequest(id).subscribe(
      () => {
        this.documentList = this.documentList.filter(obj => obj.id !== id);
      },
      error => console.log('error', error)
    );
  }

  optionChanged() {
    this.getDocumentRequestList();
  }

  pageChanged() {
    this.getDocumentRequestList();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-list/download-list.component.ts